module.exports = __webpack_public_path__ + "static/media/ThinLightBlueRectangle.d5f81508.svg";